import { useEffect, useRef } from 'react';
import { isWeb } from 'shared/src/utils';
import { useGoodsSno } from './useGoodsSno';
import { usePostAffiliateLinksAccessLogs } from '../queries/usePostAffiliateLinksAccessLogs';
import { useGoodsRoute } from '../../../hooks/useGoodsRoute';

export const useAffiliateAccessLog = () => {
  const goodsSno = useGoodsSno();
  const { mutate } = usePostAffiliateLinksAccessLogs();
  const isSent = useRef(false);
  const { params } = useGoodsRoute<'GoodsDetail'>();

  useEffect(() => {
    if (isSent.current) return;

    if (isWeb) {
      const searchParams = new URLSearchParams(window.location.search);
      const uid = searchParams.get('uid');
      if (!uid) return;
      isSent.current = true;
      mutate({ uid, goods_sno: goodsSno });
      searchParams.delete('uid');
      const nextSearch = searchParams.toString();
      const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;
      window.history.replaceState(null, '', nextUrl);
      return;
    }

    const uid = params.extras?.uid;
    if (!uid) return;
    isSent.current = true;
    mutate({ uid, goods_sno: goodsSno });
  }, [goodsSno, mutate, params.extras?.uid]);
};